//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebControls.GPodaniOpravaPisemnostiDlg.ts        </Name>
//    <Description>                                                             </Description>
//    <Author>      Šebesta David                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019                            </Copyright>
//    <Created>     2019-05-24                                                  </Created>
//  </FileHeader>


namespace Gordic.Pod.WebControls {
    const { gcontent } = Decorators

    //interface Nabidka { nazev?: string, icon?: string | string[] }


    // ##################         TODO       ##############################  
    

    // ##################        End TODO       ##############################  

    /**
     * GPodaniOpravaPisemnostiDlg
     *
     * @returns
     */
    @gcontent
    export class GPodaniOpravaPisemnostiDlg extends GContentBase {
        //#region Property
     

        private readonly Title: string

        private $Formular?: JQuery<HTMLElement>   // zakladní hlavička
        private gLogovani: Gin.Globals.Dialogs.IGLogovani
        private model: GPodaniOpravaPisemnostiDto
        private enableDto: GPodaniOpravaPisemnostiEnableDto
        private isNovePodani: boolean
        private PodPovinnostSettings: GPodPodaniPovinAPreplnSettingsDto
        private ModFormu: Interface.ModFormuPodaniEnum
        private PodDefaultSettings: Interface.GPodDefaultSettingsDto

        private Ixp: string
        private IdSpisu?: string
        private PrizCj: boolean
        private IxsTre: string
        private SelectedDenikSpz?: string
        private ProbehloUlozeni: boolean = false;

        private SeznamPriloh: GPrilohyPodavanehoDokumentuSeznamDto[] | null;
        private badgePocetPriloh: any;
        private gin_poc_priloa: number;
        private ssl_kon_poc_pri: number;
        /**
         * OnContentReady.
         *
         * @author  dsebesta
         * @date    01.09.2017
         */
        public onContentReady(): void {
            const that: GPodaniOpravaPisemnostiDlg = this;

            this.beginOperation();
      

            this.createAction();
            this.createForm();
            this.setFocus();
            this.enabledFunction(this.enableDto);


            this.setModel(this.model);
            this.ZkontroluInformaciOZmeneCiluRedistribuce();
            this.endOperation();
            this.initHelpTag();
            this.showInfoODohledaniDleZnackaOdes();
        }

        private initHelpTag() {
            this.element.addHelpContext('ElPodani');
        }
        private setFocus(): void {
            this.findFields(Wfl.Prefabs.FieldNames.adresat).gfield("focus");
        }

        private ZkontroluInformaciOZmeneCiluRedistribuce() {
            
            if (this.model.InfoZpravaOZmeneRedistribuce) {

                this.showFlash("jres:31950383" + " - " + this.model.InfoZpravaOZmeneRedistribuce, //RC 31950383 : Redistribuce
                    "info",
                    "idRedistribuceFlash"
                )
            }
        }



        private enabledFunction(enableDto: GPodaniOpravaPisemnostiEnableDto): void {
            /*
            if (this.isNovePodani) {
                this.actions[Gordic.Wfl.PreActions.Names.OtevriPrilohy].enabled(false);
            }
            */
            //Evidovat
            var evidovatField = this.findFields("Evidovat");
            evidovatField.gfield("option", "disabled", !enableDto.EvidovatEnabled);
            if (!enableDto.EvidovatVisible) { evidovatField.gformrow().hide(); }

            //Dat Doruceni
            var fieldDoruceni = this.findFields(Wfl.Prefabs.FieldNames.datumDoruceni);
            if (enableDto.DatDoruceniVisible) {
                fieldDoruceni.prev().show();
                fieldDoruceni.show();
            } else {
                fieldDoruceni.prev().hide();
                fieldDoruceni.hide();
                
            }

            //SpisObsluhaEnable
            var spisObsluhaField = this.findFields("SpisObsluha");
            spisObsluhaField.gfield("option", "disabled", !enableDto.SpisObsluhaEnable);
                //data
            var poleSpisObsluha = [{ val: "neurceno", label: "Nevytvářet" }];
            if (enableDto.VytvoritSpisEnabled) {
                poleSpisObsluha.push({ val: "VytvoritSpis", label: "Vytvořit spis" });
            }
            poleSpisObsluha.push({ val: "VlozitDoSpisu", label: "Vložit do spisu" });
            var dataspisObsluha = new Gordic.Data.View(poleSpisObsluha, { key: "val" });
            spisObsluhaField.gfield("option", "data", dataspisObsluha);

            //Dat Pod
            this.findFields(Wfl.Prefabs.FieldNames.datumpodani).gfield("option", "disabled", !enableDto.DatPodEnabled);
            

            //EvidovatDoSSL
            this.findFields("EvidovatDoSsl").gfield("option", "disabled", !enableDto.EvidovatDoSSLEnabled);
            
            if (enableDto.IsFaze_SSD) {
                this.findFields("Umisteni").gformrow().hide();
                //this.findFields("Pristup").hide(); //22.02.2022 Na žádost P juříka vráceno dsebesta //StupUtaj
            }


            //Redistribuce
            var redistribuceField = this.findFields("Redistribuce");
           
            var poleRedistribuce = [];
            poleRedistribuce.push({ val: "neurceno", label: "jres:31950314" }); 

            
            if (!enableDto.IsFaze_SSD) {
                if (enableDto.PridelitEnabled) {
                    poleRedistribuce.push({ val: "Pridelit", label: "jres:31950317" }); //RC 31950317 : Přidělit
                }
                poleRedistribuce.push({ val: "PridelitPrimo", label: "jres:31950315" }); //RC 31950315 : Přidělit přímo
            }
            if (this.enableDto.usu_predani === 1) {  
                poleRedistribuce.push({ val: "Predat", label: "jres:31950316" }); //RC 31950316 : Předat
            }
            var dataRedistribuce = new Gordic.Data.View(poleRedistribuce, { key: "val" });

            redistribuceField.gfield("option", "data", dataRedistribuce);

            if (!enableDto.IsRedistribuce) {
                (redistribuceField as any).gformsection().hide();
            }

            //if (enableDto.PridelitEnabled) {
             //   redistribuceField.gfield("setInitial", { val: "PridelitPrimo" });
            //}
            //zpusob doručení
            var zpDoruceniField = this.findFields(Wfl.Prefabs.FieldNames.zpusobDoruceni);
            // zpDoruceniField -> ZpusobDoruceniFilterAktivita
            zpDoruceniField.gfield("option", "disabled", !enableDto.ZpusobDoruceniEnabled);
            //Znacka
            this.findFields(Wfl.Prefabs.FieldNames.znacka).gfield("option", "disabled", !enableDto.ZnackaEnabled);

            //ZobrDialogShowInfoODohledaniDleZnackaOdes   -> TODO

            this.showHideRozsirenyProfil(this.model.EvidovatDoSsl);
            this.setValidators(enableDto);
        }

        private setValidators(enableDto: GPodaniOpravaPisemnostiEnableDto): void {
            //vec podrobne 
            //this.setVecPodrobneVlaidator(enableDto, this.model.EvidovatDoSsl);
            //poznamka doruceni
            if (enableDto.PoznamkaDoruceniMaxLength != null) {
                this.findFields(Wfl.Prefabs.FieldNames.poznamkaKDouruceni).gfield("option", "validators", [new Validators.Length({ max: enableDto.PoznamkaDoruceniMaxLength })])
            }


            //usesettings

            if (this.PodPovinnostSettings.PovinVec) {
                this.findFields(Wfl.Prefabs.FieldNames.vec).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinPSC) {
                this.findFields(Wfl.Prefabs.FieldNames.posta).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinStat) {
                this.findFields(Wfl.Prefabs.FieldNames.stat).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinDatOdes) {
                this.findFields(Wfl.Prefabs.FieldNames.datumOdeslani).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinDatZeDne) {
                this.findFields(Wfl.Prefabs.FieldNames.datumZeDne).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinZnackaOdes) {
                this.findFields(Wfl.Prefabs.FieldNames.znackaOdesilatele).gfield("option", "validators", [new Validators.Required()]);
            }
            if ((this.ModFormu == Interface.ModFormuPodaniEnum.NovePodaniAutomat) || this.PodPovinnostSettings.PovinOdesilatel) {
                this.findFields(Wfl.Prefabs.FieldNames.adresat).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinPodCislo) {
                this.findFields(Wfl.Prefabs.FieldNames.podaciCislo).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinPocListu) {
                this.findFields(Wfl.Prefabs.FieldNames.pocListu).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinPocStran) {
                this.findFields(Wfl.Prefabs.FieldNames.pocStran).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinPocPriloh) {
                this.findFields(Wfl.Prefabs.FieldNames.pocPriloh).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinPocListuPriloh) {
                this.findFields(Wfl.Prefabs.FieldNames.pocListuPriloh).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinPocKopii) {
                this.findFields(Wfl.Prefabs.FieldNames.pocKopii).gfield("option", "validators", [new Validators.Required()]);
            }
            if (this.PodPovinnostSettings.PovinCilPrideleni) {
                this.findFields(Wfl.Prefabs.FieldNames.vlatnik).gfield("option", "validators", [new Validators.Required()]);
            }   
        }



        private createAction(): void{
            var that = this;
            if (this.isNovePodani) {
                this.badgePocetPriloh = new GObservableObject({
                    id: "badgePocetPriloh",
                    value: 0,
                    tooltip: "jres:31950310" //RC 31950310 : Počet přidaných příloh
                })

                this.actions.add(new GAction(
                    $.extend({},
                        Gordic.Prefabs.Icons.IconToActionParams(Gordic.Gin.Globals.Icons.Prilohy()),
                         {
                            name: Gordic.Wfl.PreActions.Names.OtevriPrilohy,
                            run: function (ev, actionContext) {
                                that.otevriPrilohyKpodani();
                            }
                    }
                    )
                ));
                //

            } else {
                this.actions.add(new GAction(Gordic.Wfl.PreActions.OtevriPrilohy({
                    inputData: {
                        parentContent: this,
                        opt: {
                            Ixp: this.Ixp
                        }
                    }
                })));

            }
          

            this.actions.add(new GAction(Gordic.Prefabs.Actions.ZavritContent(
            )));

            this.actions.add(new GAction({
                name: "actUlozit",
                icon: "gi-save",
                caption: "jres:31950137", //RC 31950137 : Uložit
                
                run: function (ev, actionContext) {
                    that.zacatekUlozeni();
                }

            }));

            this.menuBar(this.actions.createBar(
                [{ action: Gordic.Wfl.PreActions.Names.OtevriPrilohy as any, favorite: true, badge: this.badgePocetPriloh }]
            ));

            var comandbarActions:any = [
                { action: this.actions.actUlozit, primary: true }
            ];
            //if (this.ModFormu !== Interface.ModFormuPodaniEnum.EditacePoElPodani) {
                comandbarActions.push(Gordic.Prefabs.Actions.Names.ZavritContent);
            //}

            this.commandBar(this.actions.createBar(comandbarActions));
        }


        private createForm(): void {
            var that = this;


            const form = new Gordic.Forms.Form({
                layoutDescriptor: "L2M2S1",
                name: "Oprava",
                //tabOptions: {
                //    title: "jres:26225303", //RC 26225303 : Hledání zásilek
                //    opened: false
                //}
            } as any)
                .addSection();



            form.addPrefab(Gin.Prefabs.GIdentifikator({
                isPid: true,
                fieldOpt: {
                    model: "model.Pid=value",
                    disabled: true
                }
            }, undefined));

            form.addPrefab(
                Wfl.Prefabs.SpojDvaPrefabyRadkuDoJednoho(
                    Wfl.Prefabs.GDatumPodani(
                        {
                            model: "model.DatPod=value",
                            valueType: "datetime",
                            minValue: new Date(Gordic.Ssl.Utils.MinimalDate)

                        }),
                    Wfl.Prefabs.GDatumDoruceni({
                        model: "model.DatDoruceni=value",
                        valueType: "datetime",
                        minValue: new Date(Gordic.Ssl.Utils.MinimalDate)

                    }),
                    { labelJakoGTextUprosted: true }
                )
            );
            form.addPrefab(Wfl.Prefabs.GAdresat(
                this.gLogovani,
                {
                    model: "model.Odesilatel_ixs_esu=value.ixs_esu;model.Odesilatel_lic=value.lic;model.Odesilatel_por_zast=value.por_zast"

                },
                {
                    label: "jres:31950073" //RC 31950073 : Odesílatel
                }
            ));
            form.addPrefab(Wfl.Prefabs.GVec(
                this.userSettings,
                {
                    model: "model.Vec=value.data"

                }
            ));
            form.addPrefab((Gordic as any).Wfl.Prefabs.GZpusobDoruceni(
                {
                    model: "model.ZpusobDoruceni=value.zpusob_dor",
                    //emptyValue: 0,
                    //emptyValue: { ZpusobDoruceni:0},
                    //emptyValue: { zpusob_dor: 0 },
                    validators: [
                        new Validators.Required(),
                        new Gordic.Validators.Base({
                            message: "Nelze zadat hodnotu neurčeno.",
                            validate: function (value) {
                                /// <summary>s the specified value.</summary>
                                /// <param name="value">The value.</param>
                                /// <returns></returns>
                                if (that.enableDto.ssl_pod_zpdorp === 1 && value && value.zpusob_dor === 0) {
                                    return false;
                                }
                                return true;
                            },

                        })

                    ],
                    serverFilters: that.enableDto.ssl_pod_zpdorp === 1 ? { zpusob_dor: "!= 0" } : undefined,
                    //modelOptions: { verificationNeeded : true}
                    change: function (ev, changeObj) {
                        var fieldPodaciCislo = that.findFields(Wfl.Prefabs.FieldNames.podaciCislo);
                        var validators = [];
                        if (that.PodPovinnostSettings.PovinPodCislo
                            && changeObj
                            && changeObj.value
                            && (changeObj.value.zpusob_dor == 30 || changeObj.value.zpusob_dor == 10) // kurýr / pošta
                        ) {
                            validators = [new Validators.Required()]
                        }
                        fieldPodaciCislo.gfield("option", "validators", validators);
                        (window as any).Utils.Form.markRequired(fieldPodaciCislo);
                    }

                })
            );
            form.addPrefab(Wfl.Prefabs.GZvlastniZachazeni(
                {
                    model: "model.DruhZachazeniDoruceni=value.druh_zas_zach",
                   // emptyValue: { druh_zas_zach: 0, druh_zas_zach_txt:"blabla" },
                    validators: [new Validators.Required()],
                    //modelOptions: { verificationNeeded: true }
                    
                })
            );
            form.addPrefab(Wfl.Prefabs.GDruhZasilky( //DruhZasilkyDoruceni
                undefined,  // TODO ZDA FUNGUJE jinak poslat vlastní change do políčka a to odstřihne ten nastavovací ansabl co by padal
                {
                    validators: [new Validators.Required()],
                    model: "model.DruhZasilkyDoruceni=value.druh_zas",
                    
                })
            );

            form.addPrefab(Wfl.Prefabs.GPodaciCislo({
                model: "model.PodaciCislo=value"
            })
            );

            form.addPrefab(
                Wfl.Prefabs.SpojDvaPrefabyRadkuDoJednoho(
                    Wfl.Prefabs.GDatumOdeslani({
                        model: "model.DatOdeslDoruceni=value",
                        minValue: new Date(Gordic.Ssl.Utils.MinimalDate)
                    }),
                    Wfl.Prefabs.GDatumZeDne(
                        {
                            model: "model.DatZeDneDoruceni=value",
                            minValue: new Date(Gordic.Ssl.Utils.MinimalDate)

                        }
                    ),
                    { labelJakoGTextUprosted: true }
                )
            );


            form.addPrefab(
                Wfl.Prefabs.SpojDvaPrefabyRadkuDoJednoho(
                    Wfl.Prefabs.GPosta(
                        {
                            model: "model.Psc=value.psc;model.Stat=value.stat",
                            serverFilters: {
                                stat: new Gordic.Forms.Dependency("Stat", "stat", true), 
                            }
                        }),
                    Wfl.Prefabs.GStat(
                        {
                            model: "model.Stat=value.stat"
                        }),
                    { labelJakoGTextUprosted: true }
                )
            );

            form.addSection();
            
            form.addPrefab(
                Wfl.Prefabs.SpojDvaPrefabyRadkuDoJednoho(
                    Wfl.Prefabs.GTypPisemnosti(
                        {
                            model: "model.TypPis=value.ixs_typ",
                            validators: [new Validators.Required()], // vždy poviné,
                            serverFilters: {
                                aktivita_ssl: this.PodDefaultSettings.TypDokAktivitaSSL ? 100 : null //aktivita_ssl , FilterAktivitaSsl , AktivitaSsl
                            },
                            change: function (ev, changeObj) {
                                
                                var value: any = changeObj.value;
                                if (value != null && that.enableDto.PristupDleTypuDok) {
                                    that.findFields("Pristup").gfield("model", "apply", { StupUtaj: value.st_utaj_id });
                                }
                                if (that.enableDto.SpZnakDleTypuDok) {
                                    if (value && value.spis_pl) { //spis_pl , spis_znak
                                        var obj: any = {};
                                        obj.SpisZnak_spis_pl = value.spis_pl;
                                        obj.SpisZnak_spis_znak = value.spis_znak;
                                        that.findFields("SpisovyZnak_plan,SpisovyZnak_znak").gfield("model", "apply", obj);
                                    }

                                }
                            }
                        }),
                    Wfl.Prefabs.GPristup(
                        {
                            model: "model.StupUtaj=value.st_utaj_id",
                            validators: [new Validators.Required()] // vždy poviné,
                            //serverFilters: this.enableDto.PristupDleTypuDok ? { st_utaj_id: new Gordic.Forms.Dependency(Wfl.Prefabs.FieldNames.typPisemnosti, "st_utaj_id", true) } : undefined
                        }
                    )
                )
            );
            
            form.addPrefab(Wfl.Prefabs.GSpisovyZnak(
                {
                    model: "model.SpisZnak_spis_pl=value.spis_pl",
                    serverFilters: {
                  //     ixs_tre: that.IxsTre 
                    }
                },
                {                   
                    model: "model.SpisZnak_spis_pl=value.spis_pl;model.SpisZnak_spis_znak=value.spis_znak",
                    //serverFilters: this.enableDto.SpZnakDleTypuDok ? {
                    //    spis_pl: new Gordic.Forms.Dependency(Wfl.Prefabs.FieldNames.typPisemnosti, "spis_pl", true),
                    //    spis_znak: new Gordic.Forms.Dependency(Wfl.Prefabs.FieldNames.typPisemnosti, "spis_znak", true),
                    //    //ixs_tre: that.IxsTre // JS 30.3.2021 
                    //} : undefined

                }
            ));
            form.addPrefab(Wfl.Prefabs.GPoznamkaKDouruceni(
                {
                    model: "model.PoznamkaDoruceni=value"

                }
            ));

            form.addPrefab(Wfl.Prefabs.GPocetListu(

                (this as any).wflDBParams, // nejde zatím číst z mainu protože se používá i v hybridu
                {
                    model: "model.PocListu=value"

                },
                {
                    model: "model.PocStran=value"

                },
                {
                    model: "model.PocPriloh=value"

                },
                {
                    model: "model.PocListuPriloh=value"

                },
                {
                    model: "model.PocKopii=value"

                },
                {

                },
                this.model.SFyz
            ));

            form.addPrefab(Wfl.Prefabs.GZnackaOdesilatele(
                {
                    model: "model.ZnackaOdesilatele=value"

                }, {
                    label: this.enableDto.ZnackaOdesilateleLabelText
                }
            ));
            form.addPrefab(Wfl.Prefabs.GSpisovaZnackaOdesilatele(
                {
                    model: "model.SpZnackaOdesilatele=value"

                }
            ));

            form.addPrefab(Wfl.Prefabs.GUmisteni(
                {
                    model: "model.Umisteni=value.umisteni"

                }
            ));

            //form.addPrefab(Wfl.Prefabs.GPristup(
            //    {
            //        model: "model.StupUtaj=value.st_utaj_id",
            //        serverFilters: this.enableDto.PristupDleTypuDok ? { st_utaj_id: new Gordic.Forms.Dependency(Wfl.Prefabs.FieldNames.typPisemnosti, "st_utaj_id", true)}:undefined
            //    }
            //));

            form.addRow("Spis").addField("gselectbox", {
                name: "SpisObsluha",
                list: true,
                itemTemplate: "{label}",
                initialValue: { val: "neurceno" },
                data: new Gordic.Data.View([
                    { val: "neurceno", label: "Nevytvářet" },
                    { val: "VytvoritSpis", label: "Vytvořit spis" },
                    { val: "VlozitDoSpisu", label: "Vložit do spisu" },
                ], { key: "val" }),
                itemWidth: "",
                model: "model.SpisObsluha = value.val",
                change: function (ev, changeObj) {
                    var value: any = changeObj.value;
                    if (value.val === "VytvoritSpis" || value.val === "VlozitDoSpisu") {
                        that.findFields("EvidovatDoSsl").gfield("setValue", true);
                        that.findFields("EvidovatDoSsl").gfield("option", "disabled", true);
                    } else {
                        that.findFields("EvidovatDoSsl").gfield("option", "disabled", false);

                    }
                }
            })
            form.addRow().addField("gcheck", {
                name: "Evidovat",
                label: "Evidovat",

                change: function (ev, changeObj) {
                    if (changeObj.value) {
                        //TODO
                    } else {
                    }
                }

            });

            form.addRow().addField("gcheck", {
                name: "EvidovatDoSsl",
                label: "Rozšířený profil",

                change: function (ev, changeObj) {
                    that.showHideRozsirenyProfil(changeObj.value);
                }

            })

            form.addSection({ name: "Redistribuce", label: "jres:31950092" }) //RC 31950092 : Redistribuce

            //JSINDELK
            //form.addPrefab(Wfl.Prefabs.GIdentifikatorSU({
            //    fieldOpt: {
            //        model: "model.IxsSU=value"
            //    }
            //}));
            //form.addPrefab(Wfl.Prefabs.GVlastnik(
            //    {
            //        model: "model.SUFuncRef=value.ixs_fun;model.SUFuncRef_IxsSU=value.ixs_su",
            //        serverFilters: {
            //            // aktivita: [100],
            //            DlePovolenychAgend: true
            //        },
            //    },
            //    {
            //        label: "jres:31950091" //RC 31950091 : Cíl přidělení / předání
            //    }
            //));

            //form.addPrefab(Wfl.Prefabs.GIdentifikatorSU({
            //    fieldOpt: {
            //        model: "model.IxsSU=value"
            //    }
            //}));
            form
                .addRow("jres:31950091") //RC 31950091 : Cíl přidělení / předání
                .addField("gselectbox", "w-12", Gin.Prefabs.Field.SpisovyUzel({
                    name: "IxsSu",
                    model: "model.{0} = value.{1}".format(GPodaniOpravaPisemnostiDtoNames.SUFuncRef_IxsSU, Gordic.Data.Readers.GinspodDtoNames.ixs_su),
                    serverFilters: {
                        aktivita: [100],
                    },
                    change: function (ev, data) {
                        if(!data.value) {
                            var funField = that.findFields("IxsFun");

                            if(funField != null) {
                                funField.gfield("clear");
                            }
                        }
                    },
                    placeholder: "jres:31950286" //RC 31950286 : Spisový uzel
                }, false))
                .addField("gselectbox", "w-12", Gin.Prefabs.Field.Funkce({
                    name: "IxsFun",
                    model: "model.SUFuncRef=value.ixs_fun",//;model.SUFuncRef_IxsSU=value.ixs_su",
                    serverFilters: {
                        aktivita: [100],
                        DlePovolenychAgend: true,
                        //this.model.Prebirajici.ixs_su
                        ixs_su: new Gordic.Forms.Dependency("IxsSu", Gordic.Data.Readers.GinspodDtoNames.ixs_su, false),
                    },
                    placeholder: "jres:31950287" //RC 31950287 : Funkce
                }, false));

                //.addField("gselectbox", "w-12", Gin.Prefabs.Field.SpisovyUzel({
                //    name: "IxsSu", 
                //    model: "model.{0} = value.{1}".format(GPodaniOpravaPisemnostiDtoNames.SUFuncRef_IxsSU, Gordic.Data.Readers.GinspodDtoNames.ixs_su),
                //    placeholder:"jres:31950286" //RC 31950286 : Spisový uzel
                //}, false))
                //.addField("gselectbox", "w-12", Gin.Prefabs.Field.Funkce({
                //    model: "model.SUFuncRef=value.ixs_fun",//;model.SUFuncRef_IxsSU=value.ixs_su",
                //    serverFilters: {
                //        aktivita: [100],
                //        DlePovolenychAgend: true,
                //        //this.model.Prebirajici.ixs_su
                //        ixs_su: new Gordic.Forms.Dependency("IxsSu", Gordic.Data.Readers.GinspodDtoNames.ixs_su, true, true),
                //    },
                //    placeholder: "jres:31950287" //RC 31950287 : Funkce
                //}, false));

            //form.addPrefab(Wfl.Prefabs.GVlastnik(
            //    {
            //        model: "model.SUFuncRef=value.ixs_fun",//;model.SUFuncRef_IxsSU=value.ixs_su",
            //        serverFilters: {
            //            // aktivita: [100],
            //            DlePovolenychAgend: true,
            //            //this.model.Prebirajici.ixs_su
            //            ixs_su: new Gordic.Forms.Dependency("IxsSu", Gordic.Data.Readers.GinspodDtoNames.ixs_su, true, true),
            //        },
            //    },
            //    {
            //        label: "" //RC 31950091 : Cíl přidělení / předání
            //    }
            //));

            var pole = [
                { val: "neurceno", label: "Nepředávat" },
                { val: "Pridelit", label: "Přidělit" },
                { val: "PridelitPrimo", label: "Přidělit přímo" },
                { val: "Predat", label: "Předat" }
            ];

            if (this.enableDto.IsFaze_SSD) {
                pole = [
                    { val: "neurceno", label: "Nepředávat" },
                    { val: "Predat", label: "Předat" }
                ];

            }


            form.addRow().addField("gselectbox", { //"Redistribuce"
                name: "Redistribuce",
                list: true,
                itemTemplate: "{label}",
                model: "model.Redistribuce=value.val",
                initialValue: {
                    val: "neurceno"
                },
                data: new Gordic.Data.View(pole, { key: "val" }),
                itemWidth: "",
                change: function (ev, changeObj) {
                    that.setValidatorsonRedistribuce(changeObj.value.val);
                },
                validators: [new Gordic.Validators.Required()]
            });

        

            form.addSection({ name: "RozsirenyProfil", label: "jres:31950085" }) //RC 31950085 : Rozšířený profil
            form.addPrefab(Wfl.Prefabs.GVecPodrobne(
                {
                    model: "model.VecPodrobne=value"
                }
            ));
            form.addPrefab(Wfl.Prefabs.GZnacka(
                {
                    model: "model.Znacka=value"
                }, {
                    label:this.enableDto.ZnackaLabelText
                }
            ));
            form.addPrefab(Wfl.Prefabs.Gpoznamka(
                {
                    model: "model.Poznamka=value"
                }
            ));
            form.addSection();
           
            this.$Formular = $("<div>").appendTo(this.element).gform("createFrom", form);
        }

        private setModel(model: GPodaniOpravaPisemnostiDto) {
            var fields = this.findFields();
            fields.gfield("model", "apply", model);
            (window as any).Utils.Form.markRequired(fields);
            this.confirmFields();
          
        } 
        private confirmFields(): void {
            var fields = this.findFields();
            var forms = this.findForms();
            forms.gform("waitForValues").done(function () {
                fields.gfield("confirm");
            });
        }
        //#endregion

        private getModel(): GPodaniOpravaPisemnostiDto {

            var newModel: GPodaniOpravaPisemnostiDto = {};
            this.findFields().gfield("model", "collect", newModel);
            var ret = $.extend({}, this.model, newModel);
            return ret;
        }

        private showHideRozsirenyProfil(isVisible: boolean): void {
            var sekce = this.findFormSections("RozsirenyProfil");
            var fieldy = sekce.findFields();
            this.setValidatorsRozsirenyProfil(this.enableDto, isVisible);
            if (isVisible) {
                for (var i = 0; i < fieldy.length; i++) {
                    fieldy.eq(i).show();
                }
                sekce.show();
            } else {
                for (var i = 0; i < fieldy.length; i++) {
                    fieldy.eq(i).hide();
                }
                sekce.hide();
            }
        }
        private setValidatorsRozsirenyProfil(enableDto: GPodaniOpravaPisemnostiEnableDto, isVisible: boolean): void {
            if (isVisible && this.PodPovinnostSettings.PovinPozn) {
                this.findFields(Wfl.Prefabs.FieldNames.poznamka).gfield("option", "validators", [new Validators.Required()]);
            } else {
                this.findFields(Wfl.Prefabs.FieldNames.poznamka).gfield("option", "validators", []);
            }
            this.setVecPodrobneVlaidator(enableDto, isVisible);
            var fields = this.findFields(Wfl.Prefabs.FieldNames.vecPodrobne + "," + Wfl.Prefabs.FieldNames.poznamka);
            (window as any).Utils.Form.markRequired(fields);
        }

        private setVecPodrobneVlaidator(enableDto: GPodaniOpravaPisemnostiEnableDto, isVisible: boolean) {
            var vecPodrobne = [];
            if (enableDto.VecPodrobneMaxLength != null) {
                vecPodrobne.push(new Validators.Length({ max: enableDto.VecPodrobneMaxLength }));
            }
            if (isVisible && this.PodPovinnostSettings.PovinVecPodrobne) {
                vecPodrobne.push(new Validators.Required());
            }
            this.findFields(Wfl.Prefabs.FieldNames.vecPodrobne).gfield("option", "validators", vecPodrobne);
        }
        //#region SetValidators

        private setValidatorsonRedistribuce(typ: string): void {
            var IxsSuField = this.findFields("IxsSu");
            var IxsIxsFuField = this.findFields("IxsFun");
            if (typ) {
                IxsSuField.gfield("setValidators", []);
                IxsIxsFuField.gfield("setValidators", []);
                switch (typ) {
                    case "neurceno":
                        break;
                    case "Pridelit":
                        IxsSuField.gfield("setValidators", [new Gordic.Validators.Required()]);
                        break;
                    case "PridelitPrimo":
                        IxsSuField.gfield("setValidators", [new Gordic.Validators.Required()]);
                        break;
                    case "Predat":
                        IxsSuField.gfield("setValidators", [new Gordic.Validators.Required()]);
                        IxsIxsFuField.gfield("setValidators", [new Gordic.Validators.Required()]);
                        break;
                    default:
                }

            }
            (window as any).Utils.Form.markRequired(IxsSuField);
            (window as any).Utils.Form.markRequired(IxsIxsFuField);
        }


        //#endregion
        //#region Ukládání
        private zacatekUlozeni(): void {
            var that = this;
           
            if (!this.findForms().gform("isValid")) return;
            var modelToSave: GPodaniOpravaPisemnostiDto = this.getModel();

            if (this.SeznamPriloh != null && this.SeznamPriloh.length > 0) {
                modelToSave.SeznamPriloh = this.SeznamPriloh; // přílohy pro nové podání

            }

            if (this.isNovePodani) { 
                var showWarning = false;
                if (that.gin_poc_priloa == 0 && that.ssl_kon_poc_pri == 1) {
                    if (modelToSave.PocPriloh != null && modelToSave.PocPriloh > 0) {
                        if (modelToSave.SeznamPriloh == null) {
                            showWarning = true;
                        }
                        else {
                            var pocetptiloh = 0;
                            for (var i = 0; i < modelToSave.SeznamPriloh.length; i++) {
                                pocetptiloh = pocetptiloh + modelToSave.SeznamPriloh[i].pocet
                            }
                            if (pocetptiloh !== modelToSave.PocPriloh) {
                                showWarning = true;
                            }
                        }
                    }
                }
                if (showWarning) {
                    this.showFlash("jres:31950384", "important", "idWarningPocetPriloh"); //RC 31950384 : Doplňte přílohy dle zadaného počtu v seznamu příloh.
                    return;
                }
            }
            

            //GSSLInit l_oInit = new GSSLInit(UserProcess);
            //string l_sDenikSpz = UserProcess.Configuration.GetParameter("g_sslden_spz");
            //if (l_sDenikSpz != "") model.TypDenikuSpz = l_oInit.GetTypDeniku(new GString(l_sDenikSpz)).ToString();


            //l_oViceDenCj = UserProcess.Configuration.GetParameter("g_vice_den_cj") == "1";

            //doděláno kuli tomu aby když je redistribuce na nepředávat, tak aby do logiky nešlo ixs fun a su
            
            if (modelToSave.Redistribuce == null || modelToSave.Redistribuce == "neurceno") {
                modelToSave.SUFuncRef_IxsSU = null;
                modelToSave.SUFuncRef = null;
            }


            if (modelToSave.Evidovat && this.enableDto.EvidovatOtazka && this.enableDto.EvidovatEnabled) {

                this.dialogs.confirm("jres:31950093", "jres:31950128").on("closed", function (ev, retVal) { //RC 31950093 : Evidovat
                    if (retVal === "yes") {
                        modelToSave.Evidovat = false;
                    }
                    that.ulozeniPoOtazceNaEvidovt(modelToSave, that.enableDto);
                });

            } else {
                that.ulozeniPoOtazceNaEvidovt(modelToSave, this.enableDto);
            }

        }

        private ulozeniPoOtazceNaEvidovt(modelToSave: GPodaniOpravaPisemnostiDto, enableDto: GPodaniOpravaPisemnostiEnableDto): void {
            var that = this;
            if ((modelToSave.TypDenikuSpz == "10" || enableDto.ViceDenSpz) && (modelToSave.SpisObsluha == "VytvoritSpis") && (this.IdSpisu == null || this.IdSpisu == "")) {
                var promisVyberDenikuSpzDlg = $.Deferred();
                if (enableDto.ViceDenSpz && (this.SelectedDenikSpz == null || this.SelectedDenikSpz == "")) {

                    Gordic.Ssl.Dialogs.VyberDenikuSpzDlg(this, null, Gordic.Global.Enums.ModOtevreni.showModalWindow).on("closed", function (ev, retVal) {
                       
                        if (retVal) {
                            
                            //that.functionOnSelectDenikSpz(retVal.sslden, retVal.typDen, retVal.prizDenCj);
                            modelToSave.TypDenikuSpz = retVal.typDen;
                            that.SelectedDenikSpz = retVal.sslden;
                        }
                        promisVyberDenikuSpzDlg.resolve();
                    });
                } else {
                    promisVyberDenikuSpzDlg.resolve();
                }
                
                promisVyberDenikuSpzDlg.done(function () {
                    
                    if (modelToSave.TypDenikuSpz == "10") {
                        var l_oParamsJSON = {
                            Sslden: that.SelectedDenikSpz,
                            NezakladatMistoTohoVratitHodnoty: true
                        };
                        Gordic.Ssl.Dialogs.VytvSpisBezInicPisDlg(that, l_oParamsJSON, Gordic.Global.Enums.ModOtevreni.showModalWindow)
                            .done(function (retVal) {
                                
                                if (retVal) {
                                    that.IdSpisu = retVal.Pid;
                                    modelToSave.IxpSpis = retVal.Pid;
                                    modelToSave.DenikSpis = retVal.Denik;
                                    modelToSave.RokSpis = retVal.Rok;
                                    modelToSave.PorCisloSpis = retVal.Poradi;
                                }
                                else {
                                    that.IdSpisu = "zrusit";
                                }
                                that.nutnyVyberDenikuCjSKontrolouTvorbyCj(modelToSave, enableDto);
                            });
                    } else {
                        that.nutnyVyberDenikuCjSKontrolouTvorbyCj(modelToSave, enableDto);
                    }
                 
                });
            
         
            }
            else {
                that.IdSpisu = "";
                that.nutnyVyberDenikuCjSKontrolouTvorbyCj(modelToSave, enableDto);
            }
      
        }


        private nutnyVyberDenikuCjSKontrolouTvorbyCj(modelToSave: GPodaniOpravaPisemnostiDto, enableDto: GPodaniOpravaPisemnostiEnableDto) {
            var that = this;
            if (!this.PrizCj) {
                this.call("NutnyVyberDenikuCjSKontrolouTvorbyCj", { IxsTyp: modelToSave.TypPis })
                    .done(function (NutnyVyberDenikuCjSKontrolouTvorbyCj) {
                        if (NutnyVyberDenikuCjSKontrolouTvorbyCj && ((that.model.TypDenikuCj == "10" || enableDto.ViceDenCj) && modelToSave.Evidovat)) {
                            Gordic.Ssl.Dialogs.VyberDenikuDlg(that, null, Gordic.Global.Enums.ModOtevreni.showModalWindow) // dsebesta pridano 18.06.2020
                                .on("closed", function (ev, retVal) {
                                    if (retVal) {
                                        modelToSave.Denik = retVal.denik;
                                        modelToSave.Poradi = retVal.poradi;
                                        modelToSave.Rok = retVal.rok;
                                        that.autorizovanePredani(modelToSave, enableDto); // dsebesta přesunuto do IFU aby se dál nepokračovalo když dají zavřít
                                    }
                                    //that.autorizovanePredani(modelToSave, enableDto); // dsebesta přesunuto do IFU aby se dál nepokračovalo když dají zavřít
                                });
                        } else {
                            that.autorizovanePredani(modelToSave, enableDto);
                        }

                    });
            } else {
                that.autorizovanePredani(modelToSave, enableDto);
            }

        }


        private autorizovanePredani(modelToSave: GPodaniOpravaPisemnostiDto, enableDto: GPodaniOpravaPisemnostiEnableDto) {
            var that = this;
            if (modelToSave.Redistribuce === "Predat" && enableDto.Ssl_aut_preBOOL && (modelToSave.SUFuncRef != null)) {
                this.call("AutorizovatPredaniPripravit", { ixsFunPre: modelToSave.SUFuncRef })
                    .done(function (retVal) { // retval  { TypAutorizace = l_eTypAutorizace, ixsFunPre = ixsFunPre, winTittle = WinTittle, }; 
                        if (retVal.typAutorizace != 0 && retVal.typAutorizace != 1) {
                            var options = {
                                WinTitle: retVal.winTittle,
                                Behaviour: "1",
                                IxsFun: retVal.ixsFunPre
                            };
                            var $div = Gordic.Wfl.Dialogs.OvereniPrebirajiciOsobyDlg(that, options, Gordic.Global.Enums.ModOtevreni.showModalWindow) // dsebesta pridano 18.06.2020

                            $div.on("closed", function (ev, retVal) {
                                if (retVal) {
                                    that.vlozitDokumentDoSpisu(modelToSave, enableDto);
                                } else {
                                    that.showFlash("jres:31950055" +" - "+ "jres:31950129" , "warning", "idAutorizaceFlash") //RC 31950129 : Autorizace neproběhla správně
                                }
                            });
                        } else {
                            that.vlozitDokumentDoSpisu(modelToSave, enableDto);
                        }

                    });
            } else {
                that.vlozitDokumentDoSpisu(modelToSave, enableDto);
            }

        }

        private vlozitDokumentDoSpisu(modelToSave: GPodaniOpravaPisemnostiDto, enableDto: GPodaniOpravaPisemnostiEnableDto) {
            var that = this;
            var vlozitDospisu = (modelToSave.SpisObsluha === "VlozitDoSpisu");
            if (vlozitDospisu) {
                var opt: Wfl.Dialogs.IOptHledatIdentDokSpis = {
                    DisableCJ: true,
                    IxpVkladanehoDok: this.Ixp,
                    TypSpis: Wfl.Interface.WflctysEnum.Spis
                };

                if (enableDto.IsFaze_SSD) {
                    Gordic.Wfl.Dialogs.HledaniSpisuProVlozeniDokumentuSimpleDlg(this)
                        .then((retVal) => {
                            if (retVal != null && retVal.showBaseSearchDialog === true) {
                                Gordic.Wfl.Dialogs.GHledatIdentDokSpisDlg(that, opt)
                                    .done(function (retVal) {
                                        if (retVal && retVal.ixp) {
                                            modelToSave.IxpVlozitDoSpisu = retVal.ixp;
                                            that.callUlozeni(modelToSave, enableDto);
                                        } else {
                                            that.showFlash("jres:31950055"  //RC 31950055 : Pozor
                                                + " - " + "jres:31950136", //RC 31950136 : Akce byla zrušena
                                                "warning",
                                                "idVlozitDokumentDoSpisuFlash"
                                            );
                                        }
                                    });
                            }
                            else {
                                if (retVal && retVal.ixp) {
                                    modelToSave.IxpVlozitDoSpisu = retVal.ixp;
                                    that.callUlozeni(modelToSave, enableDto);
                                } else {
                                    that.showFlash("jres:31950055" //RC 31950055 : Pozor
                                        + " - " + "jres:31950136", //RC 31950136 : Akce byla zrušena
                                        "warning",
                                        "idVlozitDokumentDoSpisuFlash"
                                    )
                                }
                            }
                        });
                } else {
                    Gordic.Wfl.Dialogs.GHledatIdentDokSpisDlg(this, opt)
                        .done(function (retVal) {
                            if (retVal && retVal.ixp) {
                                modelToSave.IxpVlozitDoSpisu = retVal.ixp;
                                that.callUlozeni(modelToSave, enableDto);
                            } else {
                                that.showFlash("jres:31950055"//RC 31950055 : Pozor
                                    + " - " + "jres:31950136", //RC 31950136 : Akce byla zrušena
                                    "warning",
                                    "idVlozitDokumentDoSpisuFlash"
                                )
                            }
                        });
                }
            }else {
                that.callUlozeni(modelToSave, enableDto);
            }
        }

        private callUlozeni(modelToSave: GPodaniOpravaPisemnostiDto, enableDto: GPodaniOpravaPisemnostiEnableDto) {
            var that = this;

            this.call<GPodaniOpravaPisemnostiRetDto>("ZacatekUlozeni", { model: modelToSave, enableDto: enableDto })
                .done(function (ret) {
                    if (ret) {
                        that.ProbehloUlozeni = true;
                        that.confirmFields();
                        if (ret.Model && ret.Model.TextInformacniDialogu && ret.Model.TextInformacniDialogu !== "") {
                            /*
                            that.dialogs.messageBox(
                                "jres:31950257", //RC 31950257 : Podání
                                ret.Model.TextInformacniDialogu

                            ).on("closed", function () {
                                that.tryClose({ automatickyUzavreno: true, textInformace: ret.Model.TextInformacniDialogu});
                            })
                            */
                            that.tryClose({ automatickyUzavreno: true, textInformace: ret.Model.TextInformacniDialogu, tiskPodacihoRazitka: ret.Model.TiskPodacihoRazitka });
                        } else {
                            that.tryClose({ automatickyUzavreno: true, tiskPodacihoRazitka: ret.Model.TiskPodacihoRazitka });
                        }

                    } else {
                        that.aktualizujAktZnacku();
                    }
                })
                .fail(function () {
                    that.aktualizujAktZnacku();

                });
                ;
        }

        private closing(retVal) {
            var that = this;
            var promis = $.Deferred();
            var zmenyPromise = this.zkontrolujZmeny();
            var automatickyUzavreno: boolean = false;
            if (retVal && retVal.automatickyUzavreno ) {
                automatickyUzavreno = true;
            }
            zmenyPromise.done(function () {
                if (that.enableDto.NepovolitZavritBezUlozeni && !that.ProbehloUlozeni) {
                    that.showFlash("jres:31950141", "warning","IdNelzeZavritBezUlozeni") //RC 31950141 : Nelze zavřít bez uložení
                    promis.reject();
                } else {
                    var closeObj = {
                        automatickyUzavreno: automatickyUzavreno,
                        textInformace: retVal ? retVal.textInformace : undefined,
                        tiskPodacihoRazitka: retVal ? retVal.tiskPodacihoRazitka : undefined
                    };
                    promis.resolve(closeObj);
                }

            }).fail(function () {
                promis.reject();
                if (this.ProbehloUlozeni) {
                    that.aktualizujAktZnacku();
                }
                
            });
            return promis;
        }
                
        private zkontrolujZmeny() {
            var that = this;
            var promis = $.Deferred();
            var forms = this.findForms();
            if (forms.gform("hasChanged")) {
                this.dialogs.confirm("jres:31950261", //RC 31950261 : Provedeny změny
                    "jres:31950262").on("close", function (ev, retVal) { //RC 31950262 : Na dialogu jsou provedeny neuložené změny, přejete si dialog opravdu zavřít?
                       
                        if (retVal && (retVal === "yes")) {
                            promis.resolve();
                        } else {
                            promis.reject();
                        }
                    });
            } else {
                promis.resolve();
            }
            return promis;
        };

        private otevriPrilohyKpodani() {
            var that = this;
            var l_oParamsJSON: any = {};
            if (this.SeznamPriloh != null && this.SeznamPriloh.length > 0) {
                l_oParamsJSON.SeznamPriloh = this.SeznamPriloh;
            } else {
                l_oParamsJSON.SeznamPriloh = null;
            }
            var fieldPocetPriloh = that.findFields("PocPriloh");
            var fieldPocetPrilohValue = fieldPocetPriloh.gfield("getValue");
            if (fieldPocetPrilohValue != null && fieldPocetPrilohValue > 0) {
                l_oParamsJSON.PocetInicacnichRadku = fieldPocetPrilohValue;
            }

            var opt = {
                parentContent: this,
                opt: l_oParamsJSON,
                ModOtevreni: Gordic.Global.Enums.ModOtevreni.showModalWindow
            };

            Gordic.Pod.Dialogs.GPrilohyPodavanehoDokumentuDlg(opt)
                .then(function (retval) {
                    if (retval != null && retval.SeznamPriloh != null) {
                        that.SeznamPriloh = retval.SeznamPriloh;
                        var pocetprilohRadku = that.SeznamPriloh.length; // stary postup
                        if (that.badgePocetPriloh) {
                            that.badgePocetPriloh.update({
                                value: pocetprilohRadku,
                            });
                        }

                        //if (that.gin_poc_priloa === 1) {
                            
                            var pocetptiloh = 0;
                            for (var i = 0; i < retval.SeznamPriloh.length; i++) {
                                pocetptiloh = pocetptiloh + retval.SeznamPriloh[i].pocet
                            }
                            fieldPocetPriloh.gfield("setValue", pocetptiloh);
                        //}
                                              
                    }
                })
        }

        private aktualizujAktZnacku() {
            var that = this;
            if (this.Ixp && !this.isNovePodani) {
                this.call<GPodaniOpravaPisemnostiAktualizujZnackuDto>("AktualizujZnacku", { })
                    .done(function (ret) {
                        if (ret.PrizCj > 0) {
                            var fieldEvidovat = that.findFields("Evidovat");
                            fieldEvidovat.gfield("setValue", true);
                            fieldEvidovat.gfield("confirm");

                            var fieldZnacka = that.findFields(Wfl.Prefabs.FieldNames.znacka);
                            fieldZnacka.gfield("option", "disabled",true);
                            fieldZnacka.gfield("setValue", ret.AktZnacka);
                            fieldZnacka.gfield("confirm");
                        }
                    });
            }          
        }          

        private showInfoODohledaniDleZnackaOdes() {
            var that = this;
            var forms = this.findForms();
            forms.gform("waitForValues").done(function () {
                if (that.model.ShowInfoODohledaniDleZnackaOdes) {
                    Gordic.Wfl.Dialogs.DokSpisUniversalDlg(that, { TypSeznamuDokSpis: Wfl.Interface.TypSeznamuDokSpis.seStejnouZnackouOdes, Data: that.model.InfoODohledaniDleZnackaOdesData }, Gordic.Global.Enums.ModOtevreni.showModalWindow)

                }
            });

        }
        //#endregion
    }

}